import { useCallback } from 'react';
import Modal from 'utils/packages/Modal';
import usePasscodeModal from './usePasscodeModal';
import { ThrowableFetchError } from './fetch';
const useWithPinAuthentication = () => {
    const [getPin] = usePasscodeModal();
    const withPinAuthentication = useCallback(async (params) => {
        const { title, biometryDescription, errorTitle, forcePinAuthentication, run, } = params;
        let pin;
        try {
            pin = await getPin({
                title: title || 'Enter Your Pin Code',
                biometryDescription,
                forcePinAuthentication: forcePinAuthentication ?? false,
            });
        }
        catch {
            return; // user cancelled
        }
        try {
            await run(pin);
        }
        catch (e) {
            const fetchError = e instanceof ThrowableFetchError ? e : undefined;
            if (fetchError?.fetchError.errorType === 'PinError') {
                await withPinAuthentication({
                    ...params,
                    forcePinAuthentication: true,
                });
            }
            else {
                Modal.showError(fetchError?.fetchError.errorMessage ||
                    errorTitle ||
                    'The\xa0payment\xa0didn’t\xa0go through. Please\xa0try\xa0again.');
            }
        }
    }, [getPin]);
    return withPinAuthentication;
};
export default useWithPinAuthentication;
